// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/Emails/query-appointments.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Profile_Content_ContactInfo_Email_Emails($patient_id: uuid!) {
  vaxiom_appointment_bookings(
    where: {
      appointment: { patient: { _id: { _eq: $patient_id } } }
      state: { _eq: "SCHEDULED" }
      start_time: { _gt: "now()" }
    }
    limit: 1
    order_by: { start_time: asc_nulls_last }
  ) {
    id
  }
}

`